import { LOWERCASE_LETTER, SPECIAL_CHARACTER, UPPERCASE_LETTER } from '@utils/regex';

export const isValidPassword = (password?: string | null): boolean => {
  if (!password) return false;

  const hasMinLength = password.length >= 8;
  const hasUpperCase = UPPERCASE_LETTER.test(password);
  const hasLowerCase = LOWERCASE_LETTER.test(password);
  const hasSpecialChar = SPECIAL_CHARACTER.test(password);

  return hasMinLength && hasUpperCase && hasLowerCase && hasSpecialChar;
};
